import "./App.css";
import { GlobalStateProvider } from "./context/GlobalStateContext";
import Home from "./Pages/Home";

function App() {
  return (
    <GlobalStateProvider>
      <Home />
    </GlobalStateProvider>
  );
}

export default App;
